export const SHOPPING_CART_TEST_ID = 'shopping-cart';
